import CryptoJS from 'crypto-js';
import {DATA_SETS} from '../Constants';

const LOCAL_STORAGE_KEY_URL_HASH = 'ForesightHash';

export const storeUrlHash = (hash) => {
  if (!hash) {
    hash = window.location.hash ? window.location.hash.substring(1) : '';
  }

  // Check that it isn't a keycloak hash
  if (hash.startsWith('state=')) {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEY_URL_HASH, _cleanHashForLocalStorage(hash));
};

export const clearUrlHash = () => {
  localStorage.setItem(LOCAL_STORAGE_KEY_URL_HASH, '');
};

const _cleanHashForLocalStorage = (hash) => {
  const ampInd = hash.indexOf('&');
  if (ampInd > 0) {
    hash = hash.substring(0, ampInd);
  }

  // We dont store pop_out or print in the local store because it leads to getting stuck in popout land.
  let cleanedHash = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(hash));
  cleanedHash = cleanedHash.replace(/&po=t/g, '');
  cleanedHash = cleanedHash.replace(/po=t&/g, '');
  cleanedHash = cleanedHash.replace(/&pr=t/g, '');
  cleanedHash = cleanedHash.replace(/pr=t&/g, '');

  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(cleanedHash));
};

export const destoreUrlHash = () => {
  const hash = localStorage.getItem(LOCAL_STORAGE_KEY_URL_HASH);
  if (hash && !window.location.hash) {
    window.location.hash = '#' + hash;
  }
};

export const getParamsFromUrl = (url) => {
  let indexOfAmpersand = url.hash.indexOf('&');
  // The substring removes the "#"
  let hash;
  if (-1 === indexOfAmpersand) {
    hash = url.hash.substring(1);
  } else {
    hash = url.hash.substring(1, indexOfAmpersand);
  }

  const params = {};
  try {
    const parsedHash = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(hash));
    if (parsedHash && parsedHash.length > 0) {
      const query_params = parsedHash.split('&');
      if (query_params && query_params.length > 0) {
        let idx;
        for (let i = 0; i < query_params.length; i++) {
          idx = query_params[i].indexOf('=');
          const key = query_params[i].substring(0, idx);
          const value = query_params[i].substring(idx + 1);
          params[key] = new Set(value.split(','));
        }
      }
    }
  } catch (err) {
    // Ignore error
  }
  return params;
};

export const buildUrlHash = (active_indicators,
                             active_boundaries,
                             active_overlays,
                             point,
                             map_zoom,
                             map_center,
                             popup_open,
                             graphs_open,
                             graphs_expanded,
                             pop_out,
                             pop_out_and_print,
                             app_mode,
                             point_data_display_graph,
                             data_set,
                             table_backgrounds,
                             table_directions,
                             burn,
                             prescription) => {
  let char = '';
  let queryParams = '';
  if (active_indicators && active_indicators.length > 0) {
    queryParams = char + 'i=';
    active_indicators.forEach((indicator, i) => {
      queryParams += indicator.prefix;
      if (i + 1 < active_indicators.length) {
        queryParams += ',';
      }
    });
    char = '&';
  }

  if (active_boundaries && active_boundaries.length > 0) {
    queryParams += char + 'b=';
    active_boundaries.forEach((layer, i) => {
      queryParams += layer.prefix;
      if (i + 1 < active_boundaries.length) {
        queryParams += ',';
      }
    });
    char = '&';
  }

  if (active_overlays && active_overlays.length > 0) {
    queryParams += char + 'o=';
    active_overlays.forEach((layer, i) => {
      queryParams += layer.id;
      if (i + 1 < active_overlays.length) {
        queryParams += ',';
      }
    });
    char = '&';
  }

  if (point && point.lat !== null) {
    queryParams += char + 'plat=' + formatPoint(point.lat) + '&plng=' + formatPoint(point.lng);
    char = '&';
  }

  if (map_zoom) {
    queryParams += char + 'z=' + map_zoom;
    char = '&';
  }

  if (map_center) {
    queryParams += char + 'clat=' + formatPoint(map_center[0]) + '&clng=' + formatPoint(map_center[1]);
    char = '&';
  }

  if (popup_open) {
    queryParams += char + 'pp=' + popup_open;
    char = '&';
  }

  if (graphs_open) {
    queryParams += char + 'go=t';
    char = '&';
  }

  if (graphs_expanded) {
    queryParams += char + 'ge=t';
    char = '&';
  }

  if (pop_out && !pop_out_and_print) {
    queryParams += char + 'po=t';
    char = '&';
  }

  if (pop_out_and_print) {
    queryParams += char + 'pr=t';
    char = '&';
  }

  if (app_mode) {
    queryParams += char + 'am=' + app_mode;
    char = '&';
  }

  if (!point_data_display_graph) {
    queryParams += char + 'dt=t';
    char = '&';
  }

  if (table_backgrounds) {
    queryParams += char + 'tb=' + table_backgrounds;
    char = '&';
  }

  if (table_directions) {
    queryParams += char + 'td=' + table_directions;
    char = '&';
  }

  if (burn) {
    queryParams += char + 'bid=' + burn.eventId;
    char = '&';
  }

  if (prescription) {
    queryParams += char + 'pid=' + prescription;
    char = '&';
  }

  if (data_set && data_set !== DATA_SETS.WEATHER) {
    queryParams += char + 'ds=' + data_set;
    char = '&';
  }

  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(queryParams));
};

const formatPoint = (val) => {
  if (val) {
    return Number(val).toFixed(4);
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/utils/url_utils.js